<template>
  <v-container>
    <v-layout align-center my-4>
      <v-flex shrink class="text-center">
        <v-avatar size="36">
          <v-img :src="avatar"></v-img>
        </v-avatar>
      </v-flex>
      <v-flex shrink class="headline grey--text text-center px-3">
        {{ user.name }}
      </v-flex>
      <v-flex shrink class="text-center">
        <v-btn text color="primary" class="text-none" @click="leave()">
          Sair
        </v-btn>
      </v-flex>
      <v-spacer />
      <v-flex>
        <v-col>
          <v-menu
            ref="menu"
            v-model="menu"
            locale="pt-br"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  class="text-none"
                  @click="menu = true"
                  :loading="btnLoading"
                >
                  <v-icon>  mdi-file-download-outline </v-icon>
                    Gerar Relatório
                </v-btn>
            </template>
            <v-date-picker range v-model="dates" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
              <v-btn
                text color="primary"
                :disabled="dates.length < 2"
                @click="createJson()"
                btnLoading = true>
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-flex>
      <v-spacer />
      <v-flex shrink>
        <v-btn
          icon
          color="primary"
          class="text-none"
          @click="refresh()"
          :loading="loading"
        >
          <v-icon> mdi-refresh </v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-tabs v-model="tab">
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#list"> Questionários </v-tab>
          <v-tab href="#users"> Usuários </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item value="list" class="pt-4">
            <TableList />
          </v-tab-item>
          <v-tab-item value="users" class="pt-4">
            <UserList />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TableList from '@/components/TableList'
import UserList from '@/components/UserList'
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
// import { filter } from 'vue/types/umd'

export default {
  components: {
    TableList,
    UserList
  },
  data () {
    return {
      tab: null,
      loading: false,
      menu: false,
      dates: [],
      filteredList: [],
      btnLoading: false
    }
  },
  methods: {
    ...mapActions('auth', ['logOut', 'getListagem']),
    async createJson () {
      this.btnLoading = true
      let [start, end] = this.dates.sort()
      let userList = await this.filterList(this.list, start, end)
      if (userList.length === 0) {
        this.$store.commit('snackbar/show', {
          text: 'Nenhum questionário encontrado entre as datas informadas',
          color: 'error'
        })
        this.btnLoading = false
      } else {
        let answersList = await this.getAnswersData(userList)
        this.jsonToCsv(answersList)
      }
    },
    filterList (list, start, end) {
      let newList = []
      for (let i = 0; i < list.length; i++) {
        newList.push(list[i])
        newList[i]['date'] = list[i].date.split('/').reverse().join('-')
      }
      return newList.filter(x => x['date'] >= start && x['date'] <= end)
    },
    clean () {
      this.filteredList = []
      this.dates = []
      this.btnLoading = false
    },
    jsonToCsv (answersList) {
      const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
      const header = Object.keys(answersList[0])
      let csv = answersList.map(row => header.map(fieldName => (JSON.stringify(row[fieldName], replacer))).join(','))
      csv.unshift(header.join(','))
      csv = csv.join('\r\n')
      this.saveFile(csv)
    },
    saveFile (csvFile) {
      let filename = `relatorio-abracom-${new Date().toTimeString().split(' ')[0]}.csv`
      let blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' })
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename)
      } else {
        let link = document.createElement('a')
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', filename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
      this.clean()
    },
    async refresh () {
      try {
        this.loading = true
        await this.getListagem()
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    leave () {
      this.logOut()
      this.$router.push('/login')
    },
    async getAnswersData (userList) {
      // let answers = []
      let answersList = []
      let optionsItems = this.questions.filter(x => x.type === 'options')
      let checkboxItems = this.questions.filter(x => x.type === 'checkbox')
      for (let i = 0; i < userList.length; i++) {
        let id = userList[i].id
        const { data: result } = await axios.get('/GetQuestionarioById', {
          params: {
            idQuestionario: id
          }
        })
        for (let opt of optionsItems) {
          result[opt.field] = opt.options[result[opt.field]]
        }
        for (let check of checkboxItems) {
          result[check.field] = result[check.field].map(t => check.options[t]).join(' | ')
        }
        result['email'] = 'Indisponível'
        answersList.push(result)
      }
      this.btnLoading = false
      return answersList
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'avatar', 'list']),
    ...mapGetters('form', ['questions'])
  }
}
</script>

<style>
</style>
